module.exports = __webpack_public_path__ + "img/teacher_icon.b49f9322.png";